var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipse415(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 117,
    viewBox: "0 0 117 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.189 58.0762C109.189 70.6204 104.572 82.7259 96.2199 92.085C87.8675 101.444 76.363 107.402 63.8996 108.824C51.4362 110.245 38.8856 107.03 28.6404 99.7918C18.3952 92.5536 11.1719 81.7982 8.34759 69.5762C5.52324 57.3541 7.29536 44.5201 13.3261 33.5207C19.3569 22.5214 29.2245 14.1259 41.0478 9.93495C52.8712 5.74395 65.8234 6.05049 77.4352 10.7961",
    stroke: "url(#paint0_linear_22_4579)",
    strokeWidth: 13.722,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22_4579",
    x1: 58.1124,
    y1: 7,
    x2: 11.9913,
    y2: 90.8565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBD25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E56DA1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse415);
export default __webpack_public_path__ + "static/media/Ellipse 415.dfa71e3699d1f54f5941651d809cf36e.svg";
export { ForwardRef as ReactComponent };